export const inputStyle = { width: "218px", margin: "0", background: "#fff" }

export const selectionStyle = {
    height: "40px",
    background: "rgb(255, 255, 255)",
    position: "absolute",
    bottom: "-40px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 4px 0 #00000030"
}

export const selectTagStyle = {
    position: "absolute",
    top: "50%",
    right: "10px",
    transform: "translateY(-50%)",
    color: "#666",
    background: "#fff",
    border: "1px solid #666"
}

